import React from 'react';
import { Segment, Dropdown, Form, Divider } from 'semantic-ui-react';

import { useController, useFormContext } from 'react-hook-form';

import './index.scss';

const UsersDropdown = ({ userFieldName, users, disabled }) => {
    const { control } = useFormContext();
    const { field: userField } = useController({
        name: userFieldName,
        control
    });
    return (
        <Form.Field inline>
            <label>User:</label>
            <Dropdown
                options={users}
                value={userField.value}
                onChange={(_, { value }) => { userField.onChange({ target: { name: userField.name, value } }) }}
                selection
                selectOnBlur={false}
                fluid
                text={userField.value ? (
                    users?.find(user => user.value === userField.value)?.content
                ) : 'Select a user'}
                placeholder='Select a user'
                disabled={disabled}
            />
        </Form.Field>
    )
}

const TextingControls = ({ recipientPhones, senderPhones, users, basic, userFieldName, mode = 'tab', hasTexting = true, isInline = true, isUserDropdownDisabled = false, from, to, onChangeRecipient, onChangeSender, otherControls, disabled }) => {
    const isOfficeView = mode === 'office-view';
    const isTab = mode === 'tab';
    return (
        <Segment basic={basic} className='TextingControls'>
            <Form.Group widths={userFieldName ? isOfficeView ? 4 : 3 : 2} className='TextingControls__form-group'>
                <Form.Field inline={isInline} className='TextingControls__form-field TextingControls__form-field--dropdown' required={!isInline}>
                    <label>To:</label>
                    <Dropdown
                        options={recipientPhones}
                        onChange={onChangeRecipient}
                        value={to}
                        text={to ? (
                             recipientPhones?.find(phone => phone.value === to)?.selectedOptionFormat   
                        ) : 'Select a phone number'}
                        selection
                        selectOnBlur={false}
                        fluid
                        {...(isTab && !hasTexting ? { open: false, icon: null } : {})}
                        disabled={!recipientPhones?.length || disabled}
                    />
                </Form.Field>
                <Form.Field inline={isInline} className='TextingControls__form-field TextingControls__form-field--from-dropdown' required={!isInline}>
                    <label>From:</label>
                    <Dropdown
                        options={senderPhones}
                        value={from}
                        onChange={onChangeSender}
                        selection
                        selectOnBlur={false}
                        fluid
                        placeholder='Select a sender'
                        disabled={!hasTexting}
                        {...(isTab && !hasTexting ? { open: false, icon: null } : {})}
                    />
                </Form.Field>
                {isOfficeView && <Form.Field></Form.Field>}
                {userFieldName && (
                    <UsersDropdown userFieldName={userFieldName} users={users} disabled={!hasTexting || isUserDropdownDisabled} />
                )}
            </Form.Group>
            {otherControls && (
                <Form.Group widths={userFieldName ? isOfficeView ? 4 : 3 : 2} className='TextingControls__form-group'>
                    <Form.Field inline={isInline}>
                        {otherControls}
                    </Form.Field>
                </Form.Group>
            )}
            {!isOfficeView && <Divider fitted/>}
        </Segment>
    );
};

export default TextingControls;
